import { useEffect } from 'react';
import { RecoilState, useRecoilCallback } from 'recoil';

/**
 * This hook accepts any number of {@see RecoilState}s as parameters and resets those states when the caller unmounts.
 * This is useful for simulating a natural property of local component-scoped react state, which is that it is
 * automatically "reset" when the calling component unmounts.
 */
export const useRecoilCleanup = (...recoilStates: RecoilState<any>[]) => {
  const cleanup = useRecoilCallback(({ reset }) => (): void => {
    for (const recoilState of recoilStates) {
      reset(recoilState);
    }
  }, []);

  useEffect(() => cleanup, []);
};
